// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:100,300,400,900,700,500,300,100);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  box-sizing: border-box;
  -webkit-print-color-adjust: exact;
}

body {
  background: #E0E0E0;
  font-family: "Roboto", sans-serif;
}

::selection {
  background: #f31544;
  color: #FFF;
}

::moz-selection {
  background: #f31544;
  color: #FFF;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

.col-left {
  float: left;
}

.col-right {
  float: right;
}

.head31 {
  margin-left: 55px;
}

.head3, .head31 {
  font-size: 1.75em;
  font-weight: 500;
  line-height: 1.2;
}

.ptag {
  font-size: 0.95em;
  color: #000;
  margin: 5px 0 !important;
}

.borderTable {
  border-bottom: 2px solid #6c757d;
}

.text-white {
  color: #fff !important;
}

.table-head {
  background-color: "#6c757d !important";
  margin-top: 5px;
}

#invoiceholder {
  width: 100%;
  height: 100%;
  padding: 50px 0;
}

.logo {
  width: 100%;
}

#invoice {
  position: relative;
  margin: 0 auto;
  width: 900px;
  background: #FFF;
}

[id*=invoice-] { /* Targets all id with 'col-' */
  /*  border-bottom: 1px solid #EEE;*/
  padding: 20px;
}

#invoice-top {
  border-bottom: 2px solid #6c757d;
}

#invoice-mid {
  min-height: 110px;
}

#invoice-bot {
  min-height: 240px;
}

.leftData {
  padding: 15px 0px 0px 10px;
}

.startHead {
  background: red;
}

.tableHead {
  background-color: #6c757d !important;
}

.logo {
  display: inline-block;
  vertical-align: middle;
  width: 110px;
  overflow: hidden;
}

.info {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
}

.logo img,
.clientlogo img {
  width: 100%;
}

.clientlogo {
  display: inline-block;
  vertical-align: middle;
  width: 50px;
}

.clientinfo {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
}

.title {
  float: right;
}

.title p {
  text-align: right;
}

#message {
  margin-bottom: 30px;
  display: block;
}

h2 {
  margin-bottom: 5px;
}

.col-right td {
  padding: 5px 8px;
  border: 0;
  font-size: 0.75em;
  border-bottom: 1px solid #eeeeee;
}

.col-right td label {
  margin-left: 5px;
  font-weight: 600;
  color: #444;
}

.cta-group a {
  display: inline-block;
  padding: 7px;
  border-radius: 4px;
  background: rgb(196, 57, 10);
  margin-right: 10px;
  min-width: 100px;
  text-align: center;
  color: #fff;
  font-size: 0.75em;
}

.cta-group .btn-primary {
  background: #00a63f;
}

.cta-group.mobile-btn-group {
  display: none;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  padding: 4px;
  font-size: 0.7em;
  text-align: left;
}

.tableData {
  border: 1px solid #000;
}

.titleHead {
  font-size: 1.4rem;
  font-weight: bolder;
  line-height: 1.5;
  color: #212529;
}

.tabletitle th {
  border-bottom: 2px solid #ddd;
  text-align: right;
}

.tabletitle th:nth-child(2) {
  text-align: left;
}

th {
  font-size: 0.7em;
  text-align: left;
  padding: 5px 10px;
}

.item {
  width: 50%;
}

.list-item td {
  text-align: right;
}

.list-item td:nth-child(2) {
  text-align: left;
}

.total-row th,
.total-row td {
  text-align: right;
  font-weight: 700;
  font-size: 0.75em;
  border: 0 none;
}

footer {
  border-top: 1px solid #eeeeee;
  padding: 15px 20px;
}

@media screen and (max-width: 767px) {
  h1 {
    font-size: 0.9em;
  }
  #invoice {
    width: 100%;
  }
  #message {
    margin-bottom: 20px;
  }
  [id*=invoice-] {
    padding: 20px 10px;
  }
  .logo {
    width: 140px;
  }
  .title {
    float: none;
    display: inline-block;
    vertical-align: middle;
    margin-left: 40px;
  }
  .title p {
    text-align: left;
  }
  .col-left,
  .col-right {
    width: 100%;
  }
  .table {
    margin-top: 20px;
  }
  #table {
    white-space: nowrap;
    overflow: auto;
  }
  td {
    white-space: normal;
  }
  .cta-group {
    text-align: center;
  }
  .cta-group.mobile-btn-group {
    display: block;
    margin-bottom: 20px;
  }
  /*==================== Table ====================*/
  .table-main {
    border: 0 none;
  }
  .table-main thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  .table-main tr {
    border-bottom: 2px solid #eee;
    display: block;
    margin-bottom: 20px;
  }
  .table-main td {
    font-weight: 700;
    display: block;
    padding-left: 40%;
    max-width: none;
    position: relative;
    border: 1px solid #cccaca;
    text-align: left;
  }
  .table-main td:before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    position: absolute;
    left: 10px;
    font-weight: normal;
    text-transform: uppercase;
  }
  .total-row th {
    display: none;
  }
  .total-row td {
    text-align: left;
  }
  footer {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/DeliveryNotes/invoice-style.scss"],"names":[],"mappings":"AACA;EACE,SAAA;EACA,sBAAA;EACA,iCAAA;AACF;;AACA;EACE,mBAAA;EACA,iCAAA;AAEF;;AAAA;EAAa,mBAAA;EAAqB,WAAA;AAKlC;;AAJA;EAAiB,mBAAA;EAAqB,WAAA;AAStC;;AARA;EACI,WAAA;EACA,WAAA;EACA,cAAA;AAWJ;;AATA;EACI,WAAA;AAYJ;;AAVA;EACI,YAAA;AAaJ;;AAVA;EACI,iBAAA;AAaJ;;AAXA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AAcF;;AAZA;EACE,iBAAA;EACA,WAAA;EACA,wBAAA;AAeF;;AAbA;EACI,gCAAA;AAgBJ;;AAdA;EACI,sBAAA;AAiBJ;;AAfA;EACI,sCAAA;EACA,eAAA;AAkBJ;;AAhBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAmBF;;AAjBA;EACI,WAAA;AAoBJ;;AAlBA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAqBF;;AAlBA,iBAAA,+BAAA;EACA,mCAAA;EACE,aAAA;AAqBF;;AAlBA;EAAa,gCAAA;AAsBb;;AArBA;EAAa,iBAAA;AAyBb;;AAxBA;EAAc,iBAAA;AA4Bd;;AA1BA;EACI,0BAAA;AA6BJ;;AA3BA;EACI,eAAA;AA8BJ;;AA5BA;EACI,oCAAA;AA+BJ;;AA7BA;EACI,qBAAA;EACA,sBAAA;EACH,YAAA;EACG,gBAAA;AAgCJ;;AA9BA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;AAiCJ;;AA/BA;;EAEI,WAAA;AAkCJ;;AAhCA;EACI,qBAAA;EACA,sBAAA;EACH,WAAA;AAmCD;;AAjCA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;AAoCJ;;AAlCA;EACE,YAAA;AAqCF;;AAnCA;EAAS,iBAAA;AAuCT;;AAtCA;EAAS,mBAAA;EAAqB,cAAA;AA2C9B;;AA1CA;EACI,kBAAA;AA6CJ;;AA1CA;EAEI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;AA4CJ;;AA1CA;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;AA6CJ;;AA3CA;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AA8CJ;;AA5CA;EACI,mBAAA;AA+CJ;;AA7CA;EACI,aAAA;AAgDJ;;AA9CA;EACE,WAAA;EACA,yBAAA;AAiDF;;AA/CA;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;AAkDJ;;AAhDA;EACI,sBAAA;AAmDJ;;AAjDA;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAoDJ;;AAjDA;EACE,6BAAA;EACA,iBAAA;AAoDF;;AAlDA;EACI,gBAAA;AAqDJ;;AAnDA;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AAsDJ;;AApDA;EAAM,UAAA;AAwDN;;AAvDA;EACI,iBAAA;AA0DJ;;AAxDA;EACI,gBAAA;AA2DJ;;AAzDA;;EAEI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA4DJ;;AAzDA;EACI,6BAAA;EACA,kBAAA;AA4DJ;;AAzDA;EACI;IACI,gBAAA;EA4DN;EA1DE;IACI,WAAA;EA4DN;EA1DE;IACI,mBAAA;EA4DN;EA1DE;IACI,kBAAA;EA4DN;EA1DE;IACI,YAAA;EA4DN;EA1DE;IACI,WAAA;IACA,qBAAA;IACA,sBAAA;IACA,iBAAA;EA4DN;EA1DE;IACI,gBAAA;EA4DN;EA1DE;;IAEI,WAAA;EA4DN;EA1DE;IACI,gBAAA;EA4DN;EA1DE;IACI,mBAAA;IACA,cAAA;EA4DN;EA1DE;IACI,mBAAA;EA4DN;EA1DE;IACI,kBAAA;EA4DN;EA1DE;IACI,cAAA;IACA,mBAAA;EA4DN;EA1DG,kDAAA;EACD;IACI,cAAA;EA4DN;EA1DI;IACE,YAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,kBAAA;IACA,UAAA;EA4DN;EA1DI;IACE,6BAAA;IACA,cAAA;IACA,mBAAA;EA4DN;EA1DI;IACE,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;IACA,yBAAA;IACA,gBAAA;EA4DN;EA1DI;IACE;;;KAAA;IAIA,yBAAA;IACA,kBAAA;IACA,UAAA;IACA,mBAAA;IACA,yBAAA;EA4DN;EA1DE;IACI,aAAA;EA4DN;EA1DE;IACI,gBAAA;EA4DN;EA1DE;IAAQ,kBAAA;EA6DV;AACF","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Roboto:100,300,400,900,700,500,300,100);\n*{\n  margin: 0;\n  box-sizing: border-box;\n  -webkit-print-color-adjust: exact;\n}\nbody{\n  background: #E0E0E0;\n  font-family: 'Roboto', sans-serif;\n}\n::selection {background: #f31544; color: #FFF;}\n::moz-selection {background: #f31544; color: #FFF;}\n.clearfix::after {\n    content: \"\";\n    clear: both;\n    display: table;\n}\n.col-left {\n    float: left;\n}\n.col-right {\n    float: right;\n}\n\n.head31{\n    margin-left: 55px;}\n\n.head3, .head31{\n  font-size: 1.75em;\n  font-weight: 500;\n  line-height: 1.2;\n}\n.ptag{\n  font-size: .95em;\n  color: #000;\n  margin: 5px 0!important;\n}\n.borderTable{\n    border-bottom: 2px solid #6c757d;\n}\n.text-white{\n    color: #fff!important;\n}\n.table-head{\n    background-color:'#6c757d !important';\n    margin-top: 5px\n}\n#invoiceholder{\n  width:100%;\n  height: 100%;\n  padding: 50px 0;\n}\n.logo{\n    width: 100%;\n}\n#invoice{\n  position: relative;\n  margin: 0 auto;\n  width: 900px;\n  background: #FFF;\n}\n\n[id*='invoice-']{ /* Targets all id with 'col-' */\n/*  border-bottom: 1px solid #EEE;*/\n  padding: 20px;\n}\n\n#invoice-top{border-bottom: 2px solid #6c757d;}\n#invoice-mid{min-height: 110px;}\n#invoice-bot{ min-height: 240px;}\n\n.leftData{\n    padding: 15px 0px 0px 10px;\n}\n.startHead{\n    background: red;\n}\n.tableHead{\n    background-color:#6c757d!important;\n}\n.logo{\n    display: inline-block;\n    vertical-align: middle;\n\twidth: 110px;\n    overflow: hidden;\n}\n.info{\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 20px;\n}\n.logo img,\n.clientlogo img {\n    width: 100%;\n}\n.clientlogo{\n    display: inline-block;\n    vertical-align: middle;\n\twidth: 50px;\n}\n.clientinfo {\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 20px\n}\n.title{\n  float: right;\n}\n.title p{text-align: right;}\n#message{margin-bottom: 30px; display: block;}\nh2 {\n    margin-bottom: 5px;\n    // color: #444;\n}\n.col-right td {\n    // color: #666;\n    padding: 5px 8px;\n    border: 0;\n    font-size: 0.75em;\n    border-bottom: 1px solid #eeeeee;\n}\n.col-right td label {\n    margin-left: 5px;\n    font-weight: 600;\n    color: #444;\n}\n.cta-group a {\n    display: inline-block;\n    padding: 7px;\n    border-radius: 4px;\n    background: rgb(196, 57, 10);\n    margin-right: 10px;\n    min-width: 100px;\n    text-align: center;\n    color: #fff;\n    font-size: 0.75em;\n}\n.cta-group .btn-primary {\n    background: #00a63f;\n}\n.cta-group.mobile-btn-group {\n    display: none;\n}\ntable{\n  width: 100%;\n  border-collapse: collapse;\n}\ntd{\n    padding: 4px;\n    font-size: 0.70em;\n    text-align: left;\n}\n.tableData{\n    border:1px solid #000\n}\n.titleHead{\n    font-size: 1.4rem;\n    font-weight: bolder;\n    line-height: 1.5;\n    color: #212529;\n}\n\n.tabletitle th {\n  border-bottom: 2px solid #ddd;\n  text-align: right;\n}\n.tabletitle th:nth-child(2) {\n    text-align: left;\n}\nth {\n    font-size: 0.7em;\n    text-align: left;\n    padding: 5px 10px;\n}\n.item{width: 50%;}\n.list-item td {\n    text-align: right;\n}\n.list-item td:nth-child(2) {\n    text-align: left;\n}\n.total-row th,\n.total-row td {\n    text-align: right;\n    font-weight: 700;\n    font-size: .75em;\n    border: 0 none;\n}\n\nfooter {\n    border-top: 1px solid #eeeeee;;\n    padding: 15px 20px;\n}\n\n@media screen and (max-width: 767px) {\n    h1 {\n        font-size: .9em;\n    }\n    #invoice {\n        width: 100%;\n    }\n    #message {\n        margin-bottom: 20px;\n    }\n    [id*='invoice-'] {\n        padding: 20px 10px;\n    }\n    .logo {\n        width: 140px;\n    }\n    .title {\n        float: none;\n        display: inline-block;\n        vertical-align: middle;\n        margin-left: 40px;\n    }\n    .title p {\n        text-align: left;\n    }\n    .col-left,\n    .col-right {\n        width: 100%;\n    }\n    .table {\n        margin-top: 20px;\n    }\n    #table {\n        white-space: nowrap;\n        overflow: auto;\n    }\n    td {\n        white-space: normal;\n    }\n    .cta-group {\n        text-align: center;\n    }\n    .cta-group.mobile-btn-group {\n        display: block;\n        margin-bottom: 20px;\n    }\n     /*==================== Table ====================*/\n    .table-main {\n        border: 0 none;\n    }  \n      .table-main thead {\n        border: none;\n        clip: rect(0 0 0 0);\n        height: 1px;\n        margin: -1px;\n        overflow: hidden;\n        padding: 0;\n        position: absolute;\n        width: 1px;\n      }\n      .table-main tr {\n        border-bottom: 2px solid #eee;\n        display: block;\n        margin-bottom: 20px;\n      }\n      .table-main td {\n        font-weight: 700;\n        display: block;\n        padding-left: 40%;\n        max-width: none;\n        position: relative;\n        border: 1px solid #cccaca;\n        text-align: left;\n      }\n      .table-main td:before {\n        /*\n        * aria-label has no advantage, it won't be read inside a table\n        content: attr(aria-label);\n        */\n        content: attr(data-label);\n        position: absolute;\n        left: 10px;\n        font-weight: normal;\n        text-transform: uppercase;\n      }\n    .total-row th {\n        display: none;\n    }\n    .total-row td {\n        text-align: left;\n    }\n    footer {text-align: center;}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
